var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n            Home\n        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Web Service Antrean")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Web Service Antrean - BPJS.")])])])])
}]

export { render, staticRenderFns }